<template>
  <div>
  <top-news></top-news>
  <content-main v-on:hideLoading="hideLoadingFunc"></content-main>
  <div class="more-btn-box">
    <a href="#" class="more-btn">展开全文<s class="icon"></s></a>
  </div>
  <bottom-news></bottom-news>
  <recommend-list></recommend-list>
    <loading-comp v-bind:isShow="show"></loading-comp>
  </div>
</template>
<script>
  import topNews from '../../components/article/top-hot-news.vue'
  import bottomNews from '../../components/article/bottom-hot-news.vue'
  import contentMain from '../../components/article/content-main.vue'
  import recommendList from '../../components/article/recommend-list.vue'
  import LoadingComp from '../../components/commen/loading.vue'
  export default {
    name: 'main',
    components: {
      topNews,
      bottomNews,
      contentMain,
      recommendList,
      LoadingComp
    },
    data: function () {
      return {
        show: 'block'
      }
    },
    methods: {
      hideLoadingFunc: function () {
        this.show = 'none'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/article/enter.vue